<!-- auth-unlock.component.html -->
<!--<div class="unlock-container">-->
<!--	<h1>Unlock Secure Data</h1>-->

<!--	<input type="password" [(ngModel)]="passphrase" placeholder="Enter your passphrase"/>-->
<!--	<button (click)="unlock()">Unlock</button>-->

<!--	@if (errorMessage) {-->
<!--		<p class="error">{{errorMessage}}</p>-->
<!--	}-->

<!--	&lt;!&ndash; Optional test button &ndash;&gt;-->
<!--	@if (unlocked) {-->
<!--		<div>-->
<!--			Ready-->
<!--		</div>-->
<!--	}-->
<!--</div>-->

<app-auth-wrapper>
	<div class="content-wrapper">
		<div class="w-full h-px flex-none bg-white"></div>
		<div class="auth-btn">
			<div class="auth-btn-icon"><i class="fa-sharp fal fa-lock"></i></div>
			<div class="auth-btn-text">
				<input type="password" [(ngModel)]="passphrase" class="auth-input" placeholder="ENTER YOUR PASSPHRASE"/>
			</div>
		</div>
		<!--			<input [(ngModel)]="svcAuth.clinicianEmail" class="auth-input" placeholder="Email" type="text"/>-->
		<!--			<input [(ngModel)]="svcAuth.clinicianPword" class="auth-input" placeholder="Password" type="password"/>-->

		<div (click)="unlock()" class="auth-btn">
			<div class="auth-btn-icon"><i class="fa-sharp fal fa-key"></i></div>
			<div class="auth-btn-text">Unlock</div>
		</div>
		<div (click)="faceId()" class="auth-btn">
			<div class="auth-btn-icon"><i class="fa-sharp fal fa-fingerprint"></i></div>
			<div class="auth-btn-text">Biometric Access</div>
		</div>
		<div (click)="this.svcAuthUnlock.clearKeys()" class="auth-btn">
			<div class="auth-btn-icon"><i class="fa-sharp fal fa-trash"></i></div>
			<div class="auth-btn-text">Reset Keys</div>
		</div>
	</div>
</app-auth-wrapper>